import React, { Component } from 'react'
import { preFix } from '@/constant'
import styles from './index.module.less'
import { customJump, checkCanSkip } from '@/utils/business'
import { BaseComponentItemPropsType } from '@/typings/types'

interface ItemProps {
  text: string
  targetUrl?: string
  customUrl?: string
  query?: string
}

interface IProps extends BaseComponentItemPropsType<ItemProps> {
  style: React.CSSProperties
}

class Text extends Component<IProps> {
  static config = {
    name: 'poizon-text',
  }

  componentDidMount() {}

  onClick = () => {
    const { propsConfig } = this.props
    if (propsConfig) {
      customJump({
        targetUrl: propsConfig?.targetUrl,
        customUrl: propsConfig?.customUrl,
        query: propsConfig?.query,
      })
    }
  }

  calcStyle = () => {
    const propsConfig = this.props.propsConfig || { text: '' }
    const style = this.props.style || {}
    const canSkip = checkCanSkip({
      targetUrl: propsConfig.targetUrl,
      customUrl: propsConfig.customUrl,
    })
    return !canSkip ? style : { ...style, textDecoration: 'underline' }
  }

  render() {
    const propsConfig = this.props.propsConfig || { text: '' }
    const { text } = propsConfig
    return (
      <div className={preFix + Text.name} style={{ overflow: 'hidden', paddingBottom: '10px' }}>
        <p onClick={this.onClick} className={styles.normal} style={this.calcStyle()}>
          {text}
        </p>
      </div>
    )
  }
}

export default Text
